import { HttpClient } from '@shared/adapters/HttpClient';

export interface CreateAmazonFbmShopRequest {
  name: string;
}

export interface CreateAmazonFbmShopResponse {
  success: boolean;
  message: string;
  data?: any;
}

export class AmazonFbmApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * 🎯 Crear una tienda Amazon FBM
   * POST /api/v1/shops/create/amazon-fbm
   * @param shopData - Datos de la tienda a crear
   * @returns Promise con la respuesta de la API
   */
  async createAmazonFbmShop(shopData: CreateAmazonFbmShopRequest): Promise<CreateAmazonFbmShopResponse> {
    try {
      const response = await this.httpClient.post<any>('/shops/create/amazon-fbm', shopData);

      return {
        success: true,
        message: response.message || 'Tienda Amazon FBM creada exitosamente',
        data: response,
      };
    } catch (error: any) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Error al crear la tienda Amazon FBM',
      };
    }
  }
}
